import { AnyAction } from 'redux';
import produce from 'immer';
import { TaskLogsActionTypes } from '../actions/taskLogs';
import { TaskLogsState } from '../types/state';

const initialState: TaskLogsState = {
  isLoading: false,
  isOpen: false,
  isErrored: false,
  taskLogList: null,
  inProgressTask: null,
};

const taskLogs = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case TaskLogsActionTypes.IS_LOADING: {
      return produce(state, (df) => {
        df.isLoading = action.payload;
      });
    }

    case TaskLogsActionTypes.TASK_LOGS_FETCHED: {
      return produce(state, (df) => {
        df.taskLogList = action.payload;
      });
    }

    case TaskLogsActionTypes.TASK_LOGS_FETCH_FAILED: {
      return produce(state, (df) => {
        df.isErrored = action.payload;
      });
    }

    case TaskLogsActionTypes.TOGGLE_TASK_LOGS: {
      return produce(state, (df) => {
        df.isOpen = !state.isOpen;
      });
    }

    case TaskLogsActionTypes.CLOSE_TASK_LOGS: {
      return produce(state, (df) => {
        df.isOpen = false;
      });
    }

    case TaskLogsActionTypes.SET_IN_PROGRESS_TASK_LOG: {
      return produce(state, (df) => {
        df.inProgressTask = action.payload;
      });
    }

    case TaskLogsActionTypes.RESET: {
      return produce(state, (df) => {
        df.isLoading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default taskLogs;
